export const NAVBAR_SCHEMA = {
  home: {
    text: 'CV Therapy',
    href: '/',
  },
  items: [
    {
      dropdown: false,
      isActive: false,
      text: 'aboutMe',
      icon: 'user',
      href: '/about-me',
    },
    {
      dropdown: false,
      isActive: false,
      text: 'services',
      icon: 'clipboard',
      href: '/services',
    },
    {
      dropdown: false,
      isActive: false,
      text: 'contactMe',
      icon: 'envelope',
      href: '/contact-me',
    },
    {
      dropdown: false,
      isActive: false,
      text: 'blog',
      icon: 'blog',
      href: '/blog',
    },
  ],
  language: {
    text: 'language',
    href: '/language',
  },
};

export const FOOTER_NAVBAR_SCHEMA = {
  home: NAVBAR_SCHEMA.home,
  items: NAVBAR_SCHEMA.items.concat({
    dropdown: false,
    isActive: false,
    text: 'faq',
    icon: 'question',
    href: '/faq',
  }),
  language: NAVBAR_SCHEMA.language,
};

export default {
  NAVBAR_SCHEMA,
  FOOTER_NAVBAR_SCHEMA,
};
